import axios from "../../../../../axios";

// Get Tickets
// Harshada Bhavsar - (10/04/2026)
export const ADGetTickets = async (status) => {
  return axios.get(`api/Admin/Tickets/${status}`);
};

// Approve Tickets
// Harshada Bhavsar - 13/04/2026
export const ADApproveTicket = (data) => {
  return axios.post("/api/Admin/Ticket/Approve", data, {
    headers: { "Content-Type": "application/json" },
  });
};

// Reject  Tickets
// Harshada Bhavsar - 13/04/2026
export const ADRejectTicket = (data) => {
  return axios.post("/api/Admin/Ticket/Reject", data, {
    headers: { "Content-Type": "application/json" },
  });
};

// Assign  Tickets
// Harshada Bhavsar - 13/04/2026
export const ADAssignTicket = (data) => {
  return axios.post("/api/Admin/Ticket/Assign", data, {
    headers: { "Content-Type": "application/json" },
  });
};

// In-Progress  Tickets
// Harshada Bhavsar - 13/04/2026
export const ADInProgressTicket = (data) => {
  return axios.post("/api/Admin/Ticket/MarkInProgress", data, {
    headers: { "Content-Type": "application/json" },
  });
};

// Mark Ready for Review  Tickets 
// Harshada Bhavsar - 13/04/2026
export const ADReadyForReviewTicket = (data) => {
  return axios.post("/api/Admin/Ticket/MarkReadyForReview", data, {
    headers: { "Content-Type": "application/json" },
  });
};

// Assign to reviewer Tickets 
// Harshada Bhavsar - 13/04/2026
export const ADAssignToReviewerTicket = (data) => {
  return axios.post("/api/Admin/Ticket/AssignToReviewer", data, {
    headers: { "Content-Type": "application/json" },
  });
};

// Mark Ready for Review  Tickets 
// Harshada Bhavsar - 13/04/2026
export const ADReviewInProgressTicket = (data) => {
  return axios.post("/api/Admin/Ticket/MarkReviewInProgress", data, {
    headers: { "Content-Type": "application/json" },
  });
};

// Reviewed Tickets 
// Harshada Bhavsar - 13/04/2026
export const ADReviewedTicket = (data) => {
  return axios.post("/api/Admin/Ticket/MarkReviewed", data, {
    headers: { "Content-Type": "application/json" },
  });
};


// Reopen Tickets 
// Harshada Bhavsar - 13/04/2026
export const ADReopenTicket = (data) => {
  return axios.post("/api/Admin/Ticket/Reopen", data, {
    headers: { "Content-Type": "application/json" },
  });
};

// Closed Tickets 
// Harshada Bhavsar - 13/04/2026
export const ADClosedTicket = (data) => {
  return axios.post("/api/Admin/Ticket/Close", data, {
    headers: { "Content-Type": "application/json" },
  });
}


// Hold Tickets 
// Harshada Bhavsar - 13/04/2026
export const ADHoldTicket = (data) => {
  return axios.post("/api/Admin/Ticket/Hold", data, {
    headers: { "Content-Type": "application/json" },
  });
}

// Resume Tickets 
// Harshada Bhavsar - 13/04/2026
export const ADResumeTicket = (data) => {
  return axios.post("/api/Admin/Ticket/Resume", data, {
    headers: { "Content-Type": "application/json" },
  });
}